<h1 mat-dialog-title>{{ 'Edito youtube url' | translate }}</h1>

<div mat-dialog-content>
  <form [formGroup]="videoForm">
    <mat-form-field [style.width.px]="350" appearance="outline" style="margin-top: 0.5rem">
      <mat-label>{{ 'Youtube url' | translate }}</mat-label>
      <input formControlName="youtubeUrl" matInput placeholder="{{ 'Enter youtube url' | translate }}"/>

      <mat-error *ngIf="videoForm.get('youtubeUrl')?.hasError('required')">
        {{ 'Url is required' | translate }}
      </mat-error>

      <mat-error *ngIf="videoForm.get('youtubeUrl')?.hasError('invalidUrl')">
        {{ 'Invalid YouTube URL' | translate }}
      </mat-error>

      <mat-error *ngIf="videoForm.get('youtubeUrl')?.hasError('invalidChannel')">
        {{ 'The video must be from FFK Channel' | translate }}
      </mat-error>

      <mat-icon matSuffix matTooltip="The URL should be from FFK Channel" matTooltipPosition="above">
        info
      </mat-icon>
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions>
  <button (click)="onCancel()" mat-button>{{ 'Cancel' | translate }}</button>
  <button (click)="onSave()" [disabled]="videoForm.invalid" color="primary" mat-button>
    {{ 'Update' | translate }}
  </button>
</div>
